export enum PosLocationsActionTypes {
    START_REQUEST = 'POS_LOCATIONS_START_REQUEST',
    END_REQUEST = 'POS_LOCATIONS_END_REQUEST',
    LOAD_SUCCESS = 'POS_LOCATIONS_LOAD_SUCCESS',
    LOAD_ERROR = 'POS_LOCATIONS_LOAD_ERROR',
    RESET = 'POS_LOCATIONS_RESET'
}
